//noinspection NpmUsedModulesInstalled
export const GET_CREDIT_DETAILS = "GET_CREDIT_DETAILS";
export const GET_CREDIT_DETAILS_START = "GET_CREDIT_DETAILS_START";

//B epic attached 
export const getCreditDetails = (payload, error)  => ({type: GET_CREDIT_DETAILS_START, payload, error});

export const getCreditDetailsFulfilled = (payload, error) => ({type: GET_CREDIT_DETAILS, payload, error});

export const CREATE_OR_UPDATE_CREDIT_START = 'CREATE_OR_UPDATE_CREDIT_START';
export const CREATE_OR_UPDATE_CREDIT = 'CREATE_OR_UPDATE_CREDIT';

export const createOrUpdateCredit = (info, email) => {
    return ({
        type: CREATE_OR_UPDATE_CREDIT_START,
        payload: {info, email}
    });
};

//B
export const GET_PLANS_START = 'GET_PLANS_START';
export const GET_PLANS = 'GET_PLANS';

export const getPlans = (info, email) => {
    return ({
        type: GET_PLANS_START,
        payload: {info, email}
    });
};

export const GET_INVOICES_START = 'GET_INVOICES_START';
export const GET_INVOICES = 'GET_INVOICES';

export const getInvoices = (info, email) => {
    return ({
        type: GET_INVOICES_START,
        payload: {info, email}
    });
};

//B
export const GET_EMAIL_PLANS_START = 'GET_EMAIL_PLANS_START';
export const GET_EMAIL_PLANS = 'GET_EMAIL_PLANS';

export const getEmailPlans = (info, email) => {
    return ({
        type: GET_EMAIL_PLANS_START,
        payload: {info, email}
    });
};




//B
export const ATTACH_PLAN_TO_CLIENT = 'ATTACH_PLAN_TO_CLIENT';
export const DETACH_PLAN_FROM_CLIENT = 'DETACH_PLAN_FROM_CLIENT';
export const ATTACH_PLAN_TO_CLIENT_START = 'ATTACH_PLAN_TO_CLIENT_START';
export const DETACH_PLAN_FROM_CLIENT_START = 'DETACH_PLAN_FROM_CLIENT_START';

export const attachPlanToClient = (planId)=>{
    return({
        type: ATTACH_PLAN_TO_CLIENT_START,
        payload: {planId}
    });
}

export const detachPlanFromClient = (planId)=>{
    return({
        type: DETACH_PLAN_FROM_CLIENT_START,
        payload: {planId}
    });
}


//B
export const DELETE_PLAN_FROM_CLIENT = 'DELETE_PLAN_FROM_CLIENT';
export const DELETE_PLAN_FROM_CLIENT_START = 'DELETE_PLAN_FROM_CLIENT_START';

export const deletePlanFromClient = (planId)=>{
    return({
        type: ATTACH_PLAN_TO_CLIENT,
        payload: {planId}
    });
}

export const DELETE_PLANS_FROM_CLIENT = 'DELETE_PLANS_FROM_CLIENT';
export const DELETE_PLANS_FROM_CLIENT_START = 'DELETE_PLANS_FROM_CLIENT_START';

export const deletePlansFromClient = ()=>{
    return({
        type: DELETE_PLANS_FROM_CLIENT_START,
        payload: {}
    });
}

export const getEmailPlansFulfilled = (payload, error) => ({type: GET_EMAIL_PLANS, payload, error});

export const getInvoicesFulfilled = (payload, error) => ({type: GET_INVOICES, payload, error});

export const getAvailablePlansFulfilled = (payload, error) => ({type: GET_PLANS, payload, error});

export const createOrUpdateCreditFulfilled = (payload, error) => ({type: CREATE_OR_UPDATE_CREDIT, payload, error});

export const atachPlanToClientFulfilled = (payload, error) => ({type: ATTACH_PLAN_TO_CLIENT, payload, error});

export const deletePlanFromClientFulfilled = (payload, error) => ({type: DETACH_PLAN_FROM_CLIENT, payload, error});

export const deletePlansFromClientFulfilled = (payload, error) => ({type: DELETE_PLANS_FROM_CLIENT, payload, error});

export const TOGGLE_CREDIT_DETAILS = 'TOGGLE_CREDIT_DETAILS';

export const toggleCreditDetails = () => ({type: TOGGLE_CREDIT_DETAILS});

export const DELETE_CREDIT_START='DELETE_CREDIT_START';
export const DELETE_CREDIT='DELETE_CREDIT';

export const deleteCredit = (credit)=>{
    return({
        type:DELETE_CREDIT_START,
        payload:credit
    })
}
export const deleteCreditFulfilled = (payload, error) => ({type: DELETE_CREDIT, payload, error});

export const CONFIRM_3D_SECURE = 'CONFIRM_3D_SECURE';
export const CONFIRM_3D_SECURE_START = 'CONFIRM_3D_SECURE_START';

export const confirm3dSecure = (payload) => {
    return({
        type: CONFIRM_3D_SECURE_START,
        payload
    });
}

export const confirm3dSecureFulfilled = (payload, error) => ({type: CONFIRM_3D_SECURE, payload, error});

// export const IS_STRIPE_CUSTOMER_EXISTS = "IS_STRIPE_CUSTOMER_EXISTS";
// export const IS_STRIPE_CUSTOMER_EXISTS_START = "IS_STRIPE_CUSTOMER_EXISTS_START";
//
// export function isStripeCustomerExists() {
//     return function (dispatch) {
//         dispatch({
//             type: IS_STRIPE_CUSTOMER_EXISTS_START,
//         });
//         const payload = axios.get('/api/payment/customer');
//         dispatch({
//             type: IS_STRIPE_CUSTOMER_EXISTS,
//             payload
//         });
//     }
// }




// WEBPACK FOOTER //
// ./src/containers/billing/BillingActions.js